/**
 * Hex, not `hsl()`: amCharts 4 parses hex and `rgb()` only, and both engines share this.
 */
function hslToHex(hue: number, saturation: number, lightness: number): string {
  const s = saturation / 100
  const l = lightness / 100
  const a = s * Math.min(l, 1 - l)
  const channel = (n: number) => {
    const k = (n + hue / 30) % 12
    const value = l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))

    return Math.round(value * 255)
      .toString(16)
      .padStart(2, '0')
  }

  return `#${channel(0)}${channel(8)}${channel(4)}`
}

/** Evenly spaced hues, so any number of parts stays tellable apart. */
export function seriesColours(count: number): string[] {
  return Array.from({ length: count }, (_, index) =>
    hslToHex((200 + (index * 360) / count) % 360, 60, 62)
  )
}
